import { FcsFlag } from '@/feature-flags/unleash';

export const FlagsHome = {
  id: new FcsFlag.Flag(false),
  my: new FcsFlag.Flag(false),
  recaptcha_enabled: new FcsFlag.Flag(false, 'website.live-chat.recaptcha.enabled'),
};

export function initFlagsHome() {
  FcsFlag.register('website.live-chat.rollout', FlagsHome);
}
